// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"f7b048de","512":"8e33c939"}[chunkId] + ".chunk.js";
};